var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C7.44 8.54 11.44 6 15 6C18.56 6 21.06 8.54 22 12C21.06 15.47 18.56 18 15 18C11.44 18 7.44 15.47 6.5 12Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12V12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 17.93C14.6988 16.2268 13.9941 14.1431 13.9941 12C13.9941 9.85688 14.6988 7.77322 15.9996 6.07001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 10.67C6.99998 8 5.57998 5.97 2.72998 5.5C1.72998 7 1.72998 10.5 2.95998 12C1.71998 13.5 1.71998 17 2.72998 18.5C5.57998 18.03 6.99998 16 6.99998 13.33",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 7.26001C10.2 5.88001 9.17 4.24001 8 3.00001H13.8C14.2745 2.99826 14.7342 3.16526 15.0969 3.47118C15.4596 3.7771 15.7017 4.20202 15.78 4.67001L16.01 6.07001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 17.93L15.78 19.33C15.7017 19.798 15.4596 20.2229 15.0969 20.5289C14.7342 20.8348 14.2745 21.0018 13.8 21H9.5C10.4689 19.9015 10.9993 18.4847 10.99 17.02",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishIcon);
export default __webpack_public_path__ + "static/media/fish_icon.91108ca28a7f45c5ae3b880cdc1a0aaa.svg";
export { ForwardRef as ReactComponent };